import { Container,Row,Col } from "react-bootstrap"
import { ArrowRightCircle} from "react-bootstrap-icons";
import headerImg from "../assets/img/header-img.svg"
import { useState,useEffect } from "react"
import 'animate.css'
import TrackVisibility from "react-on-screen";


export const Banner=()=>{
    const [loopNum,setLoopNum]=useState(0);
    const [isDeleting,setIsDeleting]=useState(false);
    const toRotate=["Web Developer","Web Designer","UI/UX Designer"];
    const [text,setText]=useState('');
    const [delta,setDelta]=useState(300-Math.random()*100);
    const period=2000;

    useEffect(()=>{
        let ticker=setInterval(()=>{
        tick();
        },delta)

        return ()=>{clearInterval(ticker)}
    },[text])

    const tick=()=>{
        let i=loopNum % toRotate.length;
        let fullText=toRotate[i];
        let updatedText=isDeleting?fullText.substring(0,text.length-1): fullText.substring(0,text.length+1)

        setText(updatedText);
        if(isDeleting){
            setDelta(prevDelta=>prevDelta/2)
        }

        if(!isDeleting && updatedText===fullText)
        {
            setIsDeleting(true);
            setDelta(period);
        }
        else if(isDeleting && updatedText==="")
        {
            setIsDeleting(false);
            setLoopNum(loopNum+1)
            setDelta(500);
        }
    }
   return(
    <section className="banner" id="home">
        <Container>
            <Row className="align-items-center">
                <Col xs={12} md={6} xl={7}>
                    <TrackVisibility>
                    {
                    ({isVisible})=>
                    <div className={isVisible?"animate__animated animate__fadeIn":""}>
                    <span className="tagline">
                        Welcome To My Portfolio
                    </span>
                    <h1>{`Hi I'm Md Faique a`}<span className="wrap"> {text}</span></h1>
                    <p>"Welcome to my portfolio website! My name is Md faique and I am a Web Developer. I am passionate about creating exceptional websites and have spent Number of Months honing my skills and expertise in this field. Through this website, I hope to showcase some of my best work, projects, and accomplishments to provide you with a glimpse into my capabilities and style. Whether you are here to explore my portfolio, learn more about my experience, or connect with me for a potential collaboration, I am excited to share my journey with you. Thank you for visiting and feel free to explore my website!"</p>
                    <button onClick={()=>console.log('conect')}>Let's Connect <ArrowRightCircle size={25}/></button>
                    </div>
                    }
                    </TrackVisibility>
                </Col>
                <Col xs={12} md={5} xl={5}>
                    <img src={headerImg} alt="Headder Img"/>
                </Col>
            </Row>
        </Container>

    </section>
   ) 
}
